import { Stack, Typography } from "@mui/material";
import type { InvestorPortalFeature, InvestorPortalSettings } from "../../../../api/types/investorPortalTypes";
import useClientContext from "../../../../context/useClientContext";
import { pageRoutes } from "../../../../routes";
import GeneralPageHeader from "../../../common/GeneralPageHeader";
import InvestorPortalImpersonateButton from "../InvestorPortalImpersonateButton";
import { getPageStatusFromPortalSettings } from "../pages/portalPageStatusHelper";
import PortalPageStatusChip from "../pages/PortalPageStatusChip";

interface Props {
  title: string;
  page: InvestorPortalFeature;
  portalSettings: InvestorPortalSettings | undefined;
}

const PortalWidgetSettingsPageHeader = ({ title, page, portalSettings }: Props) => {
  const { clientCode } = useClientContext();

  const pageStatus = portalSettings ? getPageStatusFromPortalSettings(page, portalSettings) : undefined;

  return (
    <GeneralPageHeader
      showDefaultBackButtonTo={`/${clientCode}/${pageRoutes.investorRelations}/${pageRoutes.settings}?tab=pages`}
      TitleComponent={
        <Stack spacing={0.5}>
          <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
            <Typography variant="h6">{title}</Typography>
            {pageStatus && <PortalPageStatusChip value={pageStatus} />}
          </Stack>
          <Typography variant="caption" color="textSecondary">
            Portal Page
          </Typography>
        </Stack>
      }
    >
      <InvestorPortalImpersonateButton variant="outlined" color="secondary" params={{ target: "Investor" }} />
    </GeneralPageHeader>
  );
};

export default PortalWidgetSettingsPageHeader;
